import types from './types';

// 選択データを保存
export const saveSelectedItemsAction = (
    screenId, compareKey, selectedItems) => ({
  type: types.SAVE_SELECTED_ITEMS,
  screenId,
  compareKey,
  selectedItems,
});

// スクロール位置を保存
export const saveScrollPositionAction = (screenId, scrollPosition) => ({
  type: types.SAVE_SCROLL_POSITION,
  screenId,
  scrollPosition,
});
